import { Button } from "@/components/ui/Button";
import { useLanguage } from "@/context/LanguageContext";
import { ArrowRightIcon } from "@heroicons/react/24/solid";
import Link from "next/link";

export default function CatchPhrase() {
  const { language } = useLanguage();
  const copy = {
    cs: {
      eyebrow: "Automatické sledování realitních portálů",
      headlineTop: "Hlídací pes na",
      headlineAccent: "nemovitosti",
      headlineBottom: "který nic nezmešká",
      subtitle:
        "Sledujeme realitní portály za vás - každou novou nabídku dostanete přímo do mailu, dříve než ostatní.",
      primary: "Vytvořit hlídacího psa",
      secondary: "Zobrazit ukázku",
    },
    en: {
      eyebrow: "Property watchdog",
      headlineTop: "Never miss",
      headlineAccent: "a property",
      headlineBottom: "again",
      subtitle:
        "We monitor real estate portals for you - every new listing lands in your inbox before others notice it.",
      primary: "Create a watchdog",
      secondary: "View demo",
    },
  }[language];

  return (
    <div className="catchphrase-root">
      <p className="catchphrase-eyebrow">{copy.eyebrow}</p>
      <h1 className="catchphrase-headline">
        {copy.headlineTop}
        <br />
        <span className="catchphrase-muted">{copy.headlineAccent}</span>
        <br />
        {copy.headlineBottom}
      </h1>
      <p className="catchphrase-sub">{copy.subtitle}</p>
      <div className="catchphrase-actions">
        <Button asChild size="lg" className="relative overflow-hidden group">
          <Link href="/#cenik">
            {copy.primary}
            <span className="absolute inset-0 opacity-0 transition group-hover:opacity-100">
              <span className="absolute -inset-y-full left-[-50%] w-[40%] rotate-12 bg-white/10 blur-md animate-[shine_1.2s_ease-out]" />
            </span>
          </Link>
        </Button>
        <Link
          href="/#ukazka"
          className="btn-ghost group relative inline-flex items-center gap-3 overflow-hidden"
        >
          {copy.secondary}
          <ArrowRightIcon className="size-4" />
          <span className="pointer-events-none absolute inset-0">
            <span className="absolute -inset-y-full left-[-50%] w-[50%] rotate-12 bg-gradient-to-r from-transparent via-white/30 to-transparent opacity-100 animate-[shimmerLoop_3s_linear_infinite]" />
          </span>
        </Link>
      </div>
    </div>
  );
}
